import React, { useState, useEffect } from 'react';
import apiClient from '../../apiClient';
import useStatusOptions from '../../hooks/useStatusOptions';
import ContactForm from '../../Component/ContactForm';
import AddLeadForm from '../../Component/BuyLeads/AddLeadForm';
import EditLeadModal from '../../Component/BuyLeads/EditLeadModal';
import NewProductForm from '../../Component/BuyLeads/NewProductForm';
import NewCompanyForm from '../../Component/BuyLeads/NewCompanyForm';
import LeadsTable from '../../Component/BuyLeads/LeadsTable';
import SearchBar from '../../Component/common/SearchBar/SearchBar';
import Button from '../../Component/common/Button/Button';
import AutoFetchLeads from '../../Component/leads/AutoFetchLeads';
import Header from '../../Component/common/Header/Header';
import { USERNAME, PASSWORD } from '../../config';
import { createTodo } from '../../api/todo';

// import './Leads.css';

const BuyLeads = () => {

  const [searchData, setSearchData] = useState({
    fromDate: '',
    toDate: '',
    responded: false,
    limit: 50,
    pageNo: 1
  });
  const [showContactForm, setShowContactForm] = useState(false);
  const [showNewProductForm, setShowNewProductForm] = useState(false);
  const [newContactData, setNewContactData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    delivery_location: ''
  });
  const [newProductData, setNewProductData] = useState({
    name: '',
    category: '',
    specifications: ''
  });
  const [showContactDropdown, setShowContactDropdown] = useState(false);
  const [contactSearch, setContactSearch] = useState('');
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [productSearch, setProductSearch] = useState('');
  const [contacts, setContacts] = useState([]);
  const [products, setProducts] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [leads, setLeads] = useState([]);
  const [allleads, setAllLeads] = useState([]);
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [editingLead, setEditingLead] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showAutoFetch, setShowAutoFetch] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);

  // Add static list of activity types
  const [activityTypeOptions] = React.useState([
    'Call',
    'Email',
    'Meeting',
    'Follow-up',
    'Other'
  ]);

  const handleAutoFetchComplete = () => {
    setShowAutoFetch(false);
    fetchAllLeads();
  };

  const addToTodo = async (lead) => {
    try {
      const newTodo = {
        id: lead.lead_id,
        name: lead.contact_name,
        number: lead.contact_phone,
        productName: lead.product_name,
        status: 'pending',
        targetDate: new Date().toISOString().split('T')[0], // default today
        source: 'leads'
      };
      const response = await createTodo(newTodo);
      if (response.status === 201) {
        alert(`leadID ${lead.lead_id} Added to todo`);
      } else {
        alert(`Failed to add leadID ${lead.lead_id} to todo`);
      }
    } catch (error) {
      console.error(`Error adding leadID ${lead.lead_id} to todo:`, error);
      alert(`Error adding leadID ${lead.lead_id} to todo`);
    }
  };
  
  const [editFormData, setEditFormData] = useState({
    contact_name: '',
    company_name: '',
    product_name: '',
    contact_phone: '',
    contact_email: '',
    delivery_location: '',
    response_notes: '',
    responded: ''
  });


  const [newLeadFormData, setNewLeadFormData] = useState({
    lead_id: '',
    contact_name: '',
    contact_id: '',
    company_id: '',
    product_id: '',
    company_name: '',
    product_name: '',
    specifications: '',
    source: '',
    contact_phone: '',
    contact_email: '',
    delivery_location: '',
    response_notes: '',
    responded: 'New',
    posted_on: new Date().toISOString(),
  });
  const [showCompanyDropdown, setShowCompanyDropdown] = useState(false);
  const [companySearch, setCompanySearch] = useState('');
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const [companies, setCompanies] = useState([]); 
  const [showCompanyForm, setShowCompanyForm] = useState(false);
  const [showSearchFilters, setShowSearchFilters] = React.useState(false);
  const [showAutoFetchLeads, setShowAutoFetchLeads] = React.useState(false);
  const [newCompanyData, setNewCompanyData] = useState({
    name: '',
    industry: '',
    website: '',
    city: '',
    state: '',
    country: '',
  });

  // const [statusOptions, setStatusOptions] = React.useState([]);

  // React.useEffect(() => {
  //   const fetchStatusOptions = async () => {
  //     try {
  //       const response = await apiClient.get('/api/status');
  //       if (response.data && Array.isArray(response.data)) {
  //         setStatusOptions(response.data.map(item => item.status));
  //       }
  //     } catch (error) {
  //       console.error('Failed to fetch status options:', error);
  //     }
  //   };
  //   fetchStatusOptions();
  // }, []);

  const { statusOptions, loading: statusLoading, error: statusError } = useStatusOptions();
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await apiClient.get('/api/companies');
        setCompanies(response.data);
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };
    fetchCompanies();
  }, []);
  const handleCompanyNameChange = (e) => {
    const value = e.target.value;
    setNewLeadFormData(prev => ({
      ...prev,
      company_name: value
    }));
    setCompanySearch(value);
    
    if (value) {
      const filtered = companies.filter(company => 
        company.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCompanies(filtered);
      setShowCompanyDropdown(true);
    } else {
      setShowCompanyDropdown(false);
    }
  };

    const toggleAutoFetchLeads = () => {
    setShowAutoFetchLeads(prev => !prev);
  };
  
  const handleCompanySelect = (company) => {
    setNewLeadFormData(prev => ({
      ...prev,
      company_name: company.name,
      company_id: company.id || ''
    }));
    setShowCompanyDropdown(false);
  };
  
  const handleAddNewCompany = async () => {
    try {
      const response = await apiClient.post('/api/add-company', newCompanyData);
      setCompanies([...companies, response.data]);
      setNewLeadFormData(prev => ({
        ...prev,
        company_name: response.data.name,
        company_id: response.data.id
      }));
      setShowCompanyForm(false);
      setNewCompanyData({ 
        name: '',
        industry: '',
        website: '',
        city: '',
        state: '',
        country: ''
      });
    } catch (error) {
      console.error('Error adding company:', error);
    }
  };

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await apiClient.get('/api/contacts');
        setContacts(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching contacts:', error);
        setIsLoading(false);
      }
    };
    fetchContacts();
  }, []);


  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await apiClient.get('/api/get-products');
        setProducts(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching contacts:', error);
        setIsLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = allleads.filter((lead) =>
      ["lead_id", "contact_name", "company_name", "product_name","contact_email","contact_phone"]
        .some((key) => lead[key]?.toLowerCase().includes(query))
    );
    setFilteredLeads(filtered);
  };

  const handleToggleAddForm = () => {
    setShowAddForm(!showAddForm);
  };

  const handleNewLeadChange = (e) => {
    const { name, value } = e.target;
    setNewLeadFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleAddNewLead = async () => {
    if (!newLeadFormData.lead_id || newLeadFormData.lead_id.trim() === '') {
      alert('Lead Id is required. Please enter a Lead Id before adding.');
      return;
    }
    if (!newLeadFormData.contact_name || newLeadFormData.contact_name.trim() === '') {
      alert('Contact Name is required. Please enter a Contact Name before adding.');
      return;
    }
    if (!newLeadFormData.contact_phone || newLeadFormData.contact_phone.trim() === '') {
      alert('Contact Phone is required. Please enter a Contact Phone before adding.');
      return;
    }
    setIsLoading(true);
    try {
      await apiClient.post('/api/add-lead', newLeadFormData);
      setMessage('New lead added successfully');
      setNewLeadFormData({
        lead_id: '',
        contact_name: '',
        company_name: '',
        product_name: '',
        contact_phone: '',
        specifications: '',
        contact_email: '',
        delivery_location: '',
        response_notes: '',
        responded: ''
      });
      await fetchAllLeads();
    } catch (error) {
      console.error('Error adding new lead:', error);
      setMessage('Failed to add new lead');
    } finally {
      setIsLoading(false);
    }
  };

  const filteredContacts = contacts.filter(contact =>
    contact.name?.toLowerCase().includes(contactSearch.toLowerCase())
  );


  const filteredProducts = products.filter(product =>
    product.name?.toLowerCase().includes(productSearch.toLowerCase())
  );

  const handleContactNameChange = (e) => {
    const value = e.target.value;
    setNewLeadFormData(prev => ({
      ...prev,
      contact_name: value
    }));
    setContactSearch(value);
    setShowContactDropdown(value.length > 0);
  };

  const handleProductNameChange = (e) => {
    const value = e.target.value;
    setNewLeadFormData(prev => ({
      ...prev,
      product_name: value

    }));
    setProductSearch(value);
    setShowProductDropdown(value.length > 0);
  };

  const handleContactSelect = (contact) => {
    setNewLeadFormData(prev => ({
      ...prev,
      contact_name: contact.name,
      company_name: contact.company_name || '',
      company_id: contact.company_id || '',
      contact_id: contact.id || '',
      contact_phone: contact.phone || '',
      contact_email: contact.email || '',
      delivery_location: contact.delivery_location || ''
    }));
    setShowContactDropdown(false);
  };

  const handleProductSelect = (product) => {
    setNewLeadFormData(prev => ({
      ...prev,
      product_name: product.name || '',
      product_id : product.id ||''
    }));
    setShowProductDropdown(false);
  };

  const handleAddNewContact = async () => {
    try {
      const response = await apiClient.post('/api/add-contact', newContactData);
      setContacts([...contacts, response.data]);
      setNewLeadFormData(prev => ({
        ...prev,
        contact_name: newContactData.name,
        company_name: newContactData.company,
        contact_phone: newContactData.phone,
        contact_email: newContactData.email,
        delivery_location: newContactData.delivery_location
      }));
      setShowContactForm(false);
    } catch (error) {
      console.error('Error adding contact:', error);
    }
  };
  
  const handleAddNewProduct = async () => {
    try {
      const response = await apiClient.post('/api/add-product', newProductData);
      setProducts([...products, response.data]);
      setNewLeadFormData(prev => ({
        ...prev,
        name: newProductData.name,
        category: newProductData.name,
        specifications: newProductData.name
      }));
      setShowNewProductForm(false);
    } catch (error) {
      console.error('Error adding product:', error);
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditClick = (lead) => {
    setEditingLead(lead.lead_id);
    setEditFormData({
      contact_name: lead.contact_name || '',
      company_name: lead.company_name || '',
      product_name: lead.product_name || '',
      contact_phone: lead.contact_phone || '',
      contact_email: lead.contact_email || '',
      delivery_location: lead.delivery_location || '',
      response_notes: lead.response_notes || '',
      old_responded: lead.responded || '',
      responded: lead.responded || '' 
    });
    setShowEditModal(true);
  };

  const handleCancelEdit = () => {
    setShowEditModal(false);
    setEditingLead(null);
  };

  const handleUpdateLead = async (updatedData) => {
    if (!editingLead) return;

    setIsLoading(true);
    try {
      // Prepare specifications data by merging standard and custom specs
      let combinedSpecs = [];
      if (updatedData.specifications && Array.isArray(updatedData.specifications)) {
        combinedSpecs = [...updatedData.specifications];
      }
      if (updatedData.customSpecs && Array.isArray(updatedData.customSpecs)) {
        // Convert custom specs to key-value pairs or desired format
        updatedData.customSpecs.forEach(customSpec => {
          combinedSpecs.push({ label: customSpec.label, value: customSpec.value });
        });
      }

      // Stringify combined specifications for backend
      const specificationsString = JSON.stringify(combinedSpecs);

      // Prepare data to send, merging updatedData and stringified specifications
      const dataToSend = {
        ...updatedData,
        specifications: specificationsString
      };

      // Update lead details
      await apiClient.post(`/api/leads/${editingLead}`, dataToSend);

      // Prepare activity log data
      const activityType = updatedData.activity_type || 'Other';
      const description = updatedData.activity_description || updatedData.response_notes || '';

      if (activityType && description) {
        const activityLogData = {
          lead_id: editingLead,
          activity_type: activityType.trim(),
          description: description.trim(),
        };

        try {
          await apiClient.post('/api/lead-activity-logs', activityLogData);
        } catch (error) {
          console.error('Error posting activity log:', error.response?.data || error.message);
          throw error;
        }
      } else {
        console.warn('Skipping activity log post due to missing activity_type or description');
      }

      setMessage('Lead and activity log updated successfully');
      setShowEditModal(false);
      await fetchAllLeads();
      setEditingLead(null);
    } catch (error) {
      console.error('Error updating lead or activity log:', error);
      setMessage('Failed to update lead or activity log');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllLeads = async () => {
    setIsLoading(true);
    try {
      const response = await apiClient.get('/api/leads', {
        username: USERNAME,
        password: PASSWORD,
        ...searchData,
      });
      const leadsData = response.data;
      setAllLeads(leadsData);
      setFilteredLeads(leadsData);
      setMessage(leadsData.length > 0 
        ? `Fetched ${leadsData.length} leads` 
        : 'No leads found for the selected criteria');
    } catch (error) {
      console.error('Error fetching leads:', error.response?.data || error.message);
      setMessage('Failed to fetch leads. Please check console for details.');
      setAllLeads([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAllLeads();
  }, []);

  const transformTradeIndiaResponse = (data) => {
    if (!data) return [];
    
    if (Array.isArray(data) && data[0]?.lead_id) {
      return data;
    }
  
    if (typeof data === 'string' && data.includes('<!DOCTYPE html>')) {
      return [];
    }
  
    const transformInquiry = (lead) => {
      const contact = lead.contact_details || {};
      return {
        lead_id: lead.lead_id || lead.rfi_id ||'N/A',
        contact_name: contact.user_name || lead.sender_name || 'N/A',
        company_name: lead.co_name || lead.sender_co|| 'N/A',
        product_name: lead.product_name || 'N/A',
        description: lead.description || lead.message ||'',
        specifications: lead.specification || '',
        phone: contact.contact_number || lead.sender_mobile || 'N/A',
        email: contact.contact_email || lead.sender_email || 'N/A',
        city: lead.city || contact.city || lead.sender_city|| 'N/A',
        state: lead.state || contact.state || lead.sender_state|| 'N/A',
        posted_on: lead.posted_on || lead.valid_from || lead.generated_date|| 'N/A',
        status: lead.user_lead_status || 'New',
        response_date: lead.response_date || 'N/A',
        response_message: lead.tl_rfi_message || lead.response_message || ''
      };
    };
  
    if (Array.isArray(data)) {
      return data.map(transformInquiry);
    }
  
    if (data?.data?.leads) {
      return data.data.leads.map(transformInquiry);
    }
  
    if (typeof data === 'object' && data !== null) {
      return [transformInquiry(data)];
    }
  
    return [];
  };
  

  const handleRowClick = (lead) => {
    setSelectedLead(lead);
  };

  const closePopup = () => {
    setSelectedLead(null);
  };

  const fetchBuyLeads = async () => {

    setIsLoading(true);
    try {
      // Fetch from both endpoints simultaneously
        const [inquiryResponse, buyLeadsResponse] = await Promise.all([
        apiClient.post('/api/inquiry', {
          username: USERNAME,
          password: PASSWORD,
          ...searchData
        }),
        apiClient.post('/api/get-buy-leads', {
          username: USERNAME,
          password: PASSWORD,
          ...searchData
        })
      ]);
  
      // Transform both responses
      const transformedInquiryLeads = transformTradeIndiaResponse(inquiryResponse.data);
      const transformedBuyLeads = transformTradeIndiaResponse(buyLeadsResponse.data);
  
      // Combine and deduplicate leads (assuming lead_id is unique)
      const combinedLeads = [...transformedInquiryLeads, ...transformedBuyLeads];
      const uniqueLeadsMap = new Map();
      
      combinedLeads.forEach(lead => {
        if (lead.lead_id && !uniqueLeadsMap.has(lead.lead_id)) {
          uniqueLeadsMap.set(lead.lead_id, lead);
        }
      });
  
      const validLeads = Array.from(uniqueLeadsMap.values())
        .filter(lead => lead.lead_id && lead.product_name);
  
      setLeads(validLeads);
      setMessage(validLeads.length > 0 
        ? `Fetched ${validLeads.length} leads from combined sources` 
        : 'No leads found for the selected criteria');
  
      fetchAllLeads();
    } catch (error) {
      console.error("Error details:", error);
      setMessage('Failed to fetch leads. Please check console for details.');
      setLeads([]);
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="buy-leads-container">
      <div className="filters-header" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
        <Header
          title="All Leads"
          onAddAction={() => setShowAddForm(true)}
        />
        <SearchBar
          placeholder="Search by Lead ID, Contact Name, Contact, Company, or Product"
          value={searchQuery}
          onChange={handleSearchInputChange}
          className="custom-search-bar"
          showIcon={true}
          style={{ flexGrow: 1, minWidth: '200px' }}
        />
        <Button onClick={handleToggleAddForm} className="btn add-new-lead-button" style={{ flexShrink: 0 }}>
          {showAddForm ? 'Close Form' : 'Add Lead'}
        </Button>
        <Button onClick={toggleAutoFetchLeads} className="btn toggle-auto-fetch-button" style={{ flexShrink: 0 }}>
          {showAutoFetchLeads ? 'Hide Auto Fetch' : 'Show Auto Fetch'}
        </Button> 
      </div>

      <AddLeadForm
        showAddForm={showAddForm}
        newLeadFormData={newLeadFormData}
        handleNewLeadChange={handleNewLeadChange}
        showContactDropdown={showContactDropdown}
        filteredContacts={filteredContacts}
        handleContactSelect={handleContactSelect}
        contactSearch={contactSearch}
        setShowContactFormCallback={setShowContactForm}
        setShowContactDropdown={setShowContactDropdown}
        showCompanyDropdown={showCompanyDropdown}
        filteredCompanies={filteredCompanies}
        handleCompanySelect={handleCompanySelect}
        showProductDropdown={showProductDropdown}
        filteredProducts={filteredProducts}
        handleProductSelect={handleProductSelect}
        handleAddNewLead={handleAddNewLead}
        isLoading={isLoading}
        handleToggleAddForm={handleToggleAddForm}
        showContactForm={showContactForm}
        newContactData={newContactData}
        setNewContactData={setNewContactData}
        handleAddNewContact={handleAddNewContact}
        showNewProductForm={showNewProductForm}
        setShowNewProductForm={setShowNewProductForm}
        newProductData={newProductData}
        setNewProductData={setNewProductData}
        showCompanyForm={showCompanyForm}
        setShowCompanyForm={setShowCompanyForm}
        newCompanyData={newCompanyData}
        setNewCompanyData={setNewCompanyData}
        handleAddNewCompany={handleAddNewCompany}
        handleContactNameChange={handleContactNameChange}
        handleCompanyNameChange={handleCompanyNameChange}
        handleProductNameChange={handleProductNameChange}
        setShowCompanyDropdown={setShowCompanyDropdown}
        companySearch={companySearch}
        setShowProductDropdown={setShowProductDropdown}
        productSearch={productSearch}
        closePopup={handleToggleAddForm}
      />
      {showAutoFetchLeads && (
        <AutoFetchLeads
          onComplete={handleAutoFetchComplete}
          setMessage={setMessage}
          setIsLoading={setIsLoading}
        />
      )}

      <EditLeadModal
        showEditModal={showEditModal}
        editingLead={editingLead}
        editFormData={editFormData}
        handleEditFormChange={handleEditFormChange}
        handleUpdateLead={handleUpdateLead}
        handleCancelEdit={handleCancelEdit}
        isLoading={isLoading}
        statusOptions={statusOptions}
        activityTypeOptions={activityTypeOptions}
      />

      {showContactForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <ContactForm 
              onSuccess={(newContact) => {
                if (newContact) {
                  handleContactSelect(newContact);
                }
                setShowContactForm(false);
              }}
            />
          </div>
        </div>
      )}

      <NewProductForm
        showNewProductForm={showNewProductForm}
        newProductData={newProductData}
        setNewProductData={setNewProductData}
        handleAddNewProduct={handleAddNewProduct}
        setShowNewProductForm={setShowNewProductForm}
      />

      <NewCompanyForm
        showCompanyForm={showCompanyForm}
        newCompanyData={newCompanyData}
        setNewCompanyData={setNewCompanyData}
        handleAddNewCompany={handleAddNewCompany}
        setShowCompanyForm={setShowCompanyForm}
      />

      <LeadsTable
        filteredLeads={filteredLeads}
        handleRowClick={handleRowClick}
        selectedLead={selectedLead}
        closePopup={closePopup}
        handleEditClick={handleEditClick}
        addToTodo={addToTodo}
        onLeadDeleted={fetchAllLeads}
      />
    </div>
  );
};

export default BuyLeads;